import { useState } from "react";
import { gql, useMutation } from "@apollo/client";

// components
import {
  Alert,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  Collapse,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../../common/loader";
import Dialog from "../../components/Dialog";

const styles = {
  gridContainer: {
    margin: "0 -12px",
  },
};

const SAVE_DISH = gql`
  mutation saveDish($dish: DishInput) {
    saveDish(dish: $dish)
  }
`;

const DishCreateDialog = (props) => {
  const { open, onClose, reloadDishes } = props;

  const [saveDish, { error: saveError, loading: saveLoading }] =
    useMutation(SAVE_DISH);

  const [dishName, setDishName] = useState("");
  const [dishRecipe, setDishRecipe] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);

  const handleClose = () => onClose();

  const createDish = () => {
    const variables = {
      dish: { name: dishName, recipe: dishRecipe },
    };
    saveDish({ variables })
      .then(() => {
        onClose();
        reloadDishes();
      })
      .catch(() => setAlertOpen(true))
      .finally();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Novo jelo</DialogTitle>
      <DialogContent>
        {saveLoading && <Loader />}
        {saveError && (
          <Collapse in={alertOpen}>
            <Alert
              severity="error"
              open={false}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => setAlertOpen(false)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {saveError.message}
            </Alert>
          </Collapse>
        )}
        {!saveLoading && (
          <Grid container spacing={3} sx={styles.gridContainer}>
            <Grid item xs={12}>
              <TextField
                label="Naziv"
                value={dishName}
                onChange={(e) => setDishName(e.target.value)}
                variant="outlined"
                fullWidth
                autoFocus
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Recept"
                value={dishRecipe}
                onChange={(e) => setDishRecipe(e.target.value)}
                variant="outlined"
                rows={4}
                fullWidth
                multiline
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Zatvori
        </Button>
        <Button
          variant="contained"
          onClick={createDish}
          color="primary"
          disabled={saveLoading}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DishCreateDialog;
